import DatePicker from 'antd/lib/date-picker';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { propTypes } from 'react-bootstrap/esm/Image';


const BzDatePicker = ({ key,disabled, className, setIsPickerOpen, handlePanelChange, dateFormat, mode, picker, dateCellRender, disabledDate, onDateChange, placeholder, defaultValue, open, style }) => {
    return (
        <DatePicker
            picker={picker}
            defaultValue={defaultValue}
            onChange={onDateChange}
            format={dateFormat}
            allowClear={false}
            inputReadOnly={true}
            showToday={false}
            disabledDate={disabledDate}
            dateRender={dateCellRender}
            mode={mode}
            className={className}
            placeholder={placeholder}
            key={key}
            disabled={disabled}
            onOpenChange={(open) => {
                if (open) {
                    setIsPickerOpen && setIsPickerOpen(true);
                } else {
                    setIsPickerOpen && setIsPickerOpen(false);
                }
            }}
            onPanelChange={handlePanelChange}
            // Mahesh S : 06-11-2023 : BT-101819 : Login Edge Cases – Issue - providing date Picker on click – Start
            open={open}
            style={style}
        // Mahesh S : 06-11-2023 : BT-101819 : Login Edge Cases – Issue - providing date Picker on click – End
        />
    );
};

BzDatePicker.propTypes = {
    arrEvents: PropTypes.array,
    dateCellRender: PropTypes.func,
    disabledDate: PropTypes.func,
    onDateChange: PropTypes.func,
    handlePanelChange: PropTypes.func,
    key: PropTypes.string,
    picker: PropTypes.string,
    mode: PropTypes.string,
    showToday: PropTypes.bool,
    allowClear: PropTypes.bool,
    inputReadOnly: PropTypes.bool,
    open: PropTypes.bool,
    disabled:propTypes.bool
};

BzDatePicker.defaultProps = {
    picker: 'date',
    allowClear: false,
    inputReadOnly: false,
    showToday: false,

};

export default memo(BzDatePicker);

